import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getPageBySlug } from '../services/pageService';
import PageRenderer from '../components/PageRenderer';
import NotFound from './NotFound';

export default function StaticPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setLoading(true);
        setError(null);
        const p = await getPageBySlug(slug);
        if (!mounted) return;
        if (!p) {
          setPage(null);
          setLoading(false);
          return;
        }
        setPage(p);
      } catch (err) { console.error(err); setError(err.message || 'Failed to load page'); }
      finally { if (mounted) setLoading(false); }
    })();
    return () => { mounted = false; };
  }, [slug]);

  if (loading) return <div className="page-container">Loading...</div>;
  if (!page) return <NotFound />;
  if (error) return <div className="page-container"><h2>Error</h2><div style={{ color: 'red' }}>{String(error)}</div></div>;

  return (
    <div className="page-container">
      <div style={{ marginTop: 12 }}>
        <PageRenderer content={page.content} pageType={page.type} />
      </div>
    </div>
  );
}
